import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const TotalPeopleCapacityInput = ({ helpText = null }) => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("totalPeopleCapacity")}
      placeholder={t("totalPeopleCapacity")}
      id="capacity"
      type="text"
      autoComplete="total people capacity"
      required={false}
      helperText={helpText}
      checkType="number"
      attr={{ maxLength: 5 }}
    />
  );
};
export default TotalPeopleCapacityInput;